export default __webpack_public_path__ + "static/media/brand-friesland.ef0e83e6.svg";